import React, { useEffect, useState, useMemo } from 'react';
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Modal,
  Box,
  TextField,
  Snackbar,
  Alert
} from '@mui/material';
import { Edit, Delete, Add, Close } from '@mui/icons-material';
import axios from 'axios';

import {
  MaterialReactTable,
  useMaterialReactTable
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';


const API_URL = process.env.REACT_APP_API_URL;

export default function Fornecedores() {
  const [fornecedores, setFornecedores] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [fornecedorAtual, setFornecedorAtual] = useState({
    nome: '', cnpj: '', telefone: '', contato: ''
  });
  const [editando, setEditando] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, mensagem: '', tipo: 'success' });
  const [erros, setErros] = useState({});
  const formatCnpj = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 14);
    return digits
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  };
  
  const formatTelefone = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 11);
    return digits.length <= 10
      ? digits.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2')
      : digits.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
  };
  
  useEffect(() => {
    fetchFornecedores();
  }, []);

const columns = useMemo(() => [
  { accessorKey: 'id', header: 'ID', size: 80 },
  { accessorKey: 'nome', header: 'Nome', filterVariant: 'text' },
  { accessorKey: 'cnpj', header: 'CNPJ', filterVariant: 'text' },
  { accessorKey: 'telefone', header: 'Telefone', filterVariant: 'text' },
  { accessorKey: 'contato', header: 'Contato', filterVariant: 'text' },
  {
    id: 'acoes',
    header: 'Ações',
    Cell: ({ row }) => (
      <Box sx={{ display: 'flex', gap: 1 }}>
        <IconButton onClick={() => handleAbrirModal(row.original)}>
          <Edit sx={{ color: "#ed3237" }} />
        </IconButton>
        <IconButton color="error" onClick={() => handleExcluir(row.original.id)}>
          <Delete />
        </IconButton>
      </Box>
    )
  }
], []);
const table = useMaterialReactTable({
  columns,
  data: fornecedores,
  localization: MRT_Localization_PT_BR,
  enableColumnFilters: true,
  enableGlobalFilter: true,
  enablePagination: true,
  enableSorting: true,
  initialState: {
    pagination: { pageSize: 50, pageIndex: 0 }
  },
  muiTablePaperProps: {
    elevation: 3,
    sx: { borderRadius: 2, mt: 3 }
  },
  muiTableContainerProps: {
    sx: { maxHeight: '65vh', overflowY: 'auto' }
  },
  muiTableHeadCellProps: {
    sx: { backgroundColor: "#f9f9f9", fontWeight: 'bold', color: '#333' }
  },
});



  const fetchFornecedores = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/fornecedores`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFornecedores(res.data);
    } catch {
      setSnackbar({ open: true, mensagem: 'Erro ao carregar fornecedores.', tipo: 'error' });
    }
  };

  const handleAbrirModal = (fornecedor = null) => {
    if (fornecedor) {
      setFornecedorAtual(fornecedor);
      setEditando(true);
    } else {
      setFornecedorAtual({ nome: '', cnpj: '', telefone: '', contato: '' });
      setEditando(false);
    }
    setErros({});
    setModalOpen(true);
  };
  
  const handleFecharModal = () => {
    setModalOpen(false);
    setFornecedorAtual({ nome: '', cnpj: '', telefone: '', contato: '' });
    setEditando(false);
    setErros({});
  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    let novoValor = value.toUpperCase();
  
    if (name === 'cnpj') novoValor = formatCnpj(novoValor);
    if (name === 'telefone') novoValor = formatTelefone(novoValor);
  
    setFornecedorAtual({ ...fornecedorAtual, [name]: novoValor });
  };
  

  const handleSalvar = async () => {
    try {
      const camposObrigatorios = ['nome', 'cnpj', 'telefone'];
      const novosErros = {};
  
      camposObrigatorios.forEach((campo) => {
        if (!fornecedorAtual[campo]?.trim()) {
          novosErros[campo] = `O campo ${campo.toUpperCase()} é obrigatório.`;
        }
      });
  
      if (Object.keys(novosErros).length > 0) {
        setErros(novosErros);
        setSnackbar({ open: true, mensagem: 'Preencha os campos obrigatórios.', tipo: 'error' });
        return;
      }
  
      setErros({});
      const token = localStorage.getItem('token');
      const dados = {
        ...fornecedorAtual,
        cnpj: fornecedorAtual.cnpj.replace(/\D/g, ''),
        telefone: fornecedorAtual.telefone.replace(/\D/g, '')
      };
  
      const url = fornecedorAtual.id
        ? `${API_URL}/fornecedores/${fornecedorAtual.id}`
        : `${API_URL}/fornecedores`;
      const method = fornecedorAtual.id ? 'put' : 'post';
  
      await axios[method](url, dados, {
        headers: { Authorization: `Bearer ${token}` }
      });
  
      fetchFornecedores();
      handleFecharModal();
      setSnackbar({ open: true, mensagem: 'Fornecedor salvo com sucesso!', tipo: 'success' });
    } catch {
      setSnackbar({ open: true, mensagem: 'Erro ao salvar fornecedor.', tipo: 'error' });
    }
  };
  

  const handleExcluir = async (id) => {
    if (!window.confirm('Deseja excluir este fornecedor?')) return;
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/fornecedores/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchFornecedores();
      setSnackbar({ open: true, mensagem: 'Fornecedor excluído com sucesso!', tipo: 'success' });
    } catch {
      setSnackbar({ open: true, mensagem: 'Erro ao excluir fornecedor.', tipo: 'error' });
    }
  };

  return (
    <Container maxWidth="" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h6" sx={{ mt: 5, mb: 3 }}>
        Fornecedores
      </Typography>

      <Button
        variant="contained"
        startIcon={<Add sx={{ color: '#ed3237' }} />}
        onClick={() => handleAbrirModal()}
        sx={{
          backgroundColor: "#3e4095",
          fontWeight: "bold",
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "#333",
            boxShadow: "0 0 0 2px #ed3237 inset"
          }
        }}
      >
        Adicionar
      </Button>

<MaterialReactTable table={table} />


      <Modal open={modalOpen} onClose={handleFecharModal}>
        <Box
          sx={{
            width: { xs: '90%', sm: '600px' },
            backgroundColor: '#fff',
            mx: 'auto',
            mt: '5%',
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
            overflow: 'hidden'
          }}
        >
          {/* HEADER GRADIENT */}
          <Box sx={{
            background: 'linear-gradient(135deg, #3e4095 0%, #ed3237 100%)',
            p: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: '#fff'
          }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {fornecedorAtual.id ? '✏️ EDITAR FORNECEDOR' : '➕ ADICIONAR FORNECEDOR'}
            </Typography>
            <IconButton onClick={handleFecharModal} sx={{ color: '#fff' }}>
              <Close />
            </IconButton>
          </Box>

          <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* SEÇÃO: INFORMAÇÕES GERAIS */}
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#3e4095', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                📋 INFORMAÇÕES GERAIS
              </Typography>
              <Box sx={{
                backgroundColor: '#f8f9fa',
                p: 3,
                borderRadius: 1.5,
                border: '1px solid #e0e0e0',
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                gap: 2
              }}>
                <TextField
                  fullWidth
                  label="NOME"
                  name="nome"
                  value={fornecedorAtual.nome}
                  onChange={handleChange}
                  error={!!erros.nome}
                  helperText={erros.nome || ''}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#fff',
                      '&:hover fieldset': { borderColor: '#ed3237' },
                      '&.Mui-focused fieldset': { borderColor: '#ed3237', borderWidth: 2 }
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#ed3237' }
                  }}
                />
                <TextField
                  fullWidth
                  label="CNPJ"
                  name="cnpj"
                  value={fornecedorAtual.cnpj}
                  onChange={handleChange}
                  error={!!erros.cnpj}
                  helperText={erros.cnpj || ''}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#fff',
                      '&:hover fieldset': { borderColor: '#ed3237' },
                      '&.Mui-focused fieldset': { borderColor: '#ed3237', borderWidth: 2 }
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#ed3237' }
                  }}
                />
                <TextField
                  fullWidth
                  label="TELEFONE"
                  name="telefone"
                  value={fornecedorAtual.telefone}
                  onChange={handleChange}
                  error={!!erros.telefone}
                  helperText={erros.telefone || ''}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#fff',
                      '&:hover fieldset': { borderColor: '#ed3237' },
                      '&.Mui-focused fieldset': { borderColor: '#ed3237', borderWidth: 2 }
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#ed3237' }
                  }}
                />
                <TextField
                  fullWidth
                  label="CONTATO"
                  name="contato"
                  value={fornecedorAtual.contato}
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#fff',
                      '&:hover fieldset': { borderColor: '#ed3237' },
                      '&.Mui-focused fieldset': { borderColor: '#ed3237', borderWidth: 2 }
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#ed3237' }
                  }}
                />
              </Box>
            </Box>

            {/* BOTÕES */}
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', pt: 2, borderTop: '1px solid #e0e0e0' }}>
              <Button
                variant="outlined"
                onClick={() => setFornecedorAtual({ nome: '', cnpj: '', telefone: '', contato: '' })}
                sx={{
                  borderColor: '#999',
                  color: '#999',
                  fontWeight: 'bold',
                  '&:hover': { backgroundColor: '#f5f5f5' }
                }}
              >
                LIMPAR
              </Button>
              <Button
                variant="outlined"
                onClick={handleFecharModal}
                sx={{
                  borderColor: '#999',
                  color: '#999',
                  fontWeight: 'bold',
                  '&:hover': { backgroundColor: '#f5f5f5' }
                }}
              >
                VOLTAR
              </Button>
              <Button
                variant="contained"
                onClick={handleSalvar}
                sx={{
                  background: 'linear-gradient(135deg, #3e4095 0%, #ed3237 100%)',
                  color: '#fff',
                  fontWeight: 'bold',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #0d0d0d 0%, #e67800 100%)'
                  }
                }}
              >
                SALVAR
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.tipo} sx={{ width: "100%" }}>
          {snackbar.mensagem}
        </Alert>
      </Snackbar>
    </Container>
  );
}
